import { graphql } from '../../../../graphql/generated';

export const UPDATE_SPECIAL_RATE_MUTATION = graphql(`
  mutation UpdateSpecialRate($id: ID!, $input: SpecialRateUpdateInput!) {
    updateSpecialRate(id: $id, input: $input) {
      id
    }
  }
`);
